import { MechanicalContractor } from './types';

export const formatAddressForDisplay = (contractor: MechanicalContractor): { display: string; full: string } => {
  if (!contractor.address || contractor.address.length === 0) {
    return { display: 'No address', full: 'No address' };
  }

  const primaryAddress = contractor.address[0];
  const parts = [];

  if (primaryAddress.address) parts.push(primaryAddress.address);
  if (primaryAddress.city) parts.push(primaryAddress.city);
  if (primaryAddress.province) {
    // Handle both string and object types for province
    const provinceName = typeof primaryAddress.province === 'string'
      ? primaryAddress.province
      : (primaryAddress.province as any).name || (primaryAddress.province as any).code;
    if (provinceName) parts.push(provinceName);
  }

  const fullAddress = parts.join(', ') || 'No address';

  // Truncate if longer than 35 characters
  let displayAddress = fullAddress;
  if (fullAddress.length > 35) {
    displayAddress = fullAddress.substring(0, 35) + '...';
  }

  return { display: displayAddress, full: fullAddress };
};

export const formatLocalsForDisplay = (contractor: MechanicalContractor): { display: string; full: string } => {
  let fullLocals = '';

  // For now, use simple string. Later will be calculated from contractorTrades
  if (contractor.locals) {
    fullLocals = contractor.locals;
  } else if (contractor.contractorTrades && contractor.contractorTrades.length > 0) {
    // Calculate from contractorTrades if available
    const uniqueLocalsMap = new Map();

    contractor.contractorTrades
      .filter(trade => trade.localUnion)
      .forEach(trade => {
        const local = trade.localUnion!;
        uniqueLocalsMap.set(local.id, `Local ${local.unionNumber}`);
      });

    const localsList = Array.from(uniqueLocalsMap.values());
    fullLocals = localsList.length > 0 ? localsList.join(', ') : 'No locals assigned';
  } else {
    fullLocals = 'No locals assigned';
  }

  // Truncate if longer than 30 characters
  let displayLocals = fullLocals;
  if (fullLocals.length > 30) {
    displayLocals = fullLocals.substring(0, 30) + '...';
  }

  return { display: displayLocals, full: fullLocals };
};

export const formatTradesForDisplay = (contractor: MechanicalContractor): { display: string; full: string } => {
  let fullTrades = '';
  if (contractor.contractorTrades && contractor.contractorTrades.length > 0) {
    // Filter out trades that don't have a local union
    fullTrades = contractor.contractorTrades.filter(trade => trade.localUnion).map(trade => trade.trade?.name).join(', ');
  }
  fullTrades = fullTrades || 'No trades assigned';

  // Truncate if longer than 30 characters
  let displayTrades = fullTrades;
  if (fullTrades.length > 30) {
    displayTrades = fullTrades.substring(0, 30) + '...';
  }

  return { display: displayTrades, full: fullTrades };
};